import { useAuth } from '../auth/AuthContext';

export function UnauthorizedPage() {
  const { user, signOut } = useAuth();

  return (
    <section className="mx-auto max-w-md py-20 text-center">
      <p className="text-sm uppercase tracking-widest text-nm-accent">403</p>
      <h1 className="mt-2 text-3xl font-semibold">Not on the allowlist</h1>
      <p className="mt-3 text-sm text-nm-muted">
        You signed in as <span className="font-mono text-nm-ink">{user?.email}</span>, but that
        Google account is not in <code className="text-nm-ink">VITE_AUTHORIZED_EMAILS</code>.
      </p>
      <button
        onClick={() => void signOut()}
        className="mt-6 rounded-md border border-nm-border px-4 py-2 text-sm text-nm-ink hover:border-nm-accent"
      >
        Sign out and try a different account
      </button>
    </section>
  );
}
